import setLang from '../lang';

const lang = {
    i: {
        locale: 'zh-UG',
        select: {
            placeholder: 'تاللاش',
            noMatch: 'ئۇچۇر يوق',
            loading: 'سەل ساقلاش'
        },
        table: {
            noDataText: 'ئۇچۇر يوق',
            noFilteredDataText: 'بۇنداق نەتىجە يوق',
            confirmFilter: 'تاسقاش',
            resetFilter: 'تازلاش',
            clearFilter: 'بارلىق',
            sumText: 'جەمئىي'
        },
        datepicker: {
            selectDate: 'چىسلا تاللاش',
            selectTime: 'ۋاقىت تاللاش',
            startTime: 'باشلىنىش',
            endTime: 'ئاخىرلىشىش',
            clear: 'بىكارلاش',
            ok: 'جەزىملەش',
            datePanelLabel: '[yyyyيىل] [mئاي]',
            month: 'ئاي',
            month1: '1-ئاي',
            month2: '2-ئاي',
            month3: '3-ئاي',
            month4: '4-ئاي',
            month5: '5-ئاي',
            month6: '6-ئاي',
            month7: '7-ئاي',
            month8: '8-ئاي',
            month9: '9-ئاي',
            month10: '10-ئاي',
            month11: '11-ئاي',
            month12: '12-ئاي',
            year: 'يىل',
            weekStartDay: '0',
            weeks: {
                sun: 'يەك',
                mon: 'دۈ',
                tue: 'سەي',
                wed: 'چار',
                thu: 'پەي',
                fri: 'جۈ',
                sat: 'شەن'
            },
            months: {
                m1: '1-ئاي',
                m2: '2-ئاي',
                m3: '3-ئاي',
                m4: '4-ئاي',
                m5: '5-ئاي',
                m6: '6-ئاي',
                m7: '7-ئاي',
                m8: '8-ئاي',
                m9: '9-ئاي',
                m10: '10-ئاي',
                m11: '11-ئاي',
                m12: '12-ئاي'
            }
        },
        transfer: {
            titles: {
                source: 'ئەسلى تىزىملىك',
                target: 'نىشان تىزىملىك'
            },
            filterPlaceholder: 'ئىزدەيدىغان مەزمۇننى كىرگۈزۈڭ',
            notFoundText: 'ئۇچۇر يوق'
        },
        modal: {
            okText: 'جەزىملەش',
            cancelText: 'بىكار قىلىش'
        },
        poptip: {
            okText: 'جەزىملەش',
            cancelText: 'بىكار قىلىش'
        },
        page: {
            prev: 'ئالدىنقى بەت',
            next: 'كىيىنكى بەت',
            total: 'جەمئىي',
            item: 'تال',
            items: 'تال',
            prev5: 'ئالدىغا 5 بەت',
            next5: 'ئارقىغا 5 بەت',
            page: 'تال/ھەر بىر بەت',
            goto: 'ئاتلاش',
            p: 'بەت'
        },
        rate: {
            star: 'يۇلتۇز',
            stars: 'يۇلتۇز'
        },
        time: {
            before: ' بۇرۇن',
            after: ' كىيىن',
            just: 'بايىلا',
            seconds: ' سىكونت',
            minutes: ' مىنۇت',
            hours: ' سائەت',
            days: ' كۈن'
        },
        tree: {
            emptyText: 'ئۇچۇر يوق'
        }
    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./src/locale/lang/zh-UG.js